import userStore from '~/redux/user/store'


export const getSvodRedirect = () => {
    const user = userStore.getState().user
    return user && user.redirectUrl
}

export const redirectLocation = () => {
    if(window.location.href.includes('embed/player')){
      window.location.reload();
    } else {
      window.location.href = window.location.pathname
    }
}